// extracted by mini-css-extract-plugin
export var button = "highlights-section-module--button--53de2";
export var container = "highlights-section-module--container--5c47f";
export var content = "highlights-section-module--content--defbe";
export var image = "highlights-section-module--image--6c6dc";
export var imageBanner = "highlights-section-module--imageBanner--49a8a";
export var preTitle = "highlights-section-module--preTitle--c5119";
export var section = "highlights-section-module--section--3ee6d";
export var text = "highlights-section-module--text--913d1";
export var titleBanner = "highlights-section-module--titleBanner--34a19";
export var wrapperBanner = "highlights-section-module--wrapperBanner--30e55";
export var wrapperContent = "highlights-section-module--wrapperContent--763dd";
export var wrapperImage = "highlights-section-module--wrapperImage--6a1a3";